import React from "react";
import Layout from "./Components/Layout";
import styles from "./styles/InnerPage.module.css";

export default function Contact() {
  return (
    <Layout
      title="Contact us | MyChineseHoroscope.com"
      description="Get in touch with MyChineseHoroscope.com for questions about your Chinese Zodiac sign, horoscope insights, or subscriptions."
    >
      <div className={styles.page}>
        <div className={styles.container}>
          
          <header className={styles.hero}>
            <p className={styles.kicker}>MyChineseHoroscope.com</p>
            <h1 className={styles.h1}>Contact us</h1>
            <p className={styles.sub}>
              We’re here to help with your Chinese Zodiac, horoscope insights, and account questions.
            </p>
          </header>

          <section className={styles.card}>
            <h2 className={styles.sectionTitle}>Get in touch</h2>

            <p className={styles.p}>
              If you have questions about your zodiac sign, compatibility results,
              subscription, or technical issues, feel free to contact us.
            </p>

            <div className={styles.divider} />

            <p className={styles.p}>
              📧 Email us directly at:
            </p>

            <p className={styles.p}>
              <strong>
                <a href="mailto:info@mychinesehoroscope.com">
                  info@mychinesehoroscope.com
                </a>
              </strong>
            </p>

            <div className={styles.divider} />

            <p className={styles.p}>
              We typically respond within 24–48 hours.  
              For zodiac-related questions, please include your full date of birth (YYYY-MM-DD)
              so we can assist you more efficiently.
            </p>
          </section>

          <section className={styles.card}>
            <h2 className={styles.sectionTitle}>Support & enquiries</h2>

            <ul className={styles.list}>
              <li>Chinese Zodiac sign clarification</li>
              <li>Compatibility questions</li>
              <li>Subscription or billing support</li>
              <li>Technical issues</li>
              <li>Partnership enquiries</li>
            </ul>
          </section>

        </div>
      </div>
    </Layout>
  );
}